// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"0b34076e","827":"0b34076e"}[chunkId] + ".chunk.css";
};